'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./ProjectReport.scss');

var ProjectReportProperty = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(ProjectReportProperty, _Component);

  function ProjectReportProperty() {
    (0, _classCallCheck3.default)(this, ProjectReportProperty);
    return (0, _possibleConstructorReturn3.default)(this, (ProjectReportProperty.__proto__ || (0, _getPrototypeOf2.default)(ProjectReportProperty)).apply(this, arguments));
  }

  (0, _createClass3.default)(ProjectReportProperty, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          value = _props.value;


      return _react2.default.createElement(
        'div',
        { className: styles.propertyRow },
        _react2.default.createElement(
          'div',
          { className: styles.propertyName },
          title
        ),
        _react2.default.createElement(
          'div',
          { className: styles.propertyValue },
          value
        )
      );
    }
  }]);
  return ProjectReportProperty;
}(_react.Component), _class.propTypes = {
  title: _propTypes2.default.string,
  value: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string, _propTypes2.default.number])
}, _temp);
exports.default = ProjectReportProperty;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectReport/ProjectReportProperty.js
// module id = 2058
// module chunks = 1